/** Cozy-five hub catalog (REDESIGN.md §6). */

export const COZY_HUB_SECTIONS = {
  nightlyRitual: {
    id: 'nightlyRitual',
    title: 'Nightly ritual',
    blurb: 'Gentle dailies to wind down with.',
  },
  unhurried: {
    id: 'unhurried',
    title: 'Unhurried',
    blurb: 'Take your time — no clock.',
  },
  exploreFind: {
    id: 'exploreFind',
    title: 'Explore & find',
    blurb: 'Tap letters and submit what you find.',
  },
};

export const COZY_HUB_SECTION_ORDER = [
  'nightlyRitual',
  'unhurried',
  'exploreFind',
];

/** @typedef {'wordMaster'|'letterHive'|'wordRungs'|'wordSquare'|'hiddenWords'} CozyHubGameId */

export const COZY_HUB_GAMES = [
  {
    id: 'wordMaster',
    section: 'nightlyRitual',
    name: 'Word Master',
    description: 'One calm word to guess — daily or practice',
    minutesLabel: '~5 min',
    path: '/word-master',
    icon: '📝',
  },
  {
    id: 'letterHive',
    section: 'nightlyRitual',
    name: 'Letter Hive',
    description: 'Find words in today\'s honeycomb',
    minutesLabel: '~8 min',
    path: '/letter-hive',
    iconId: 'letter-hive',
  },
  {
    id: 'wordRungs',
    section: 'unhurried',
    name: 'Word Rungs',
    description: 'Climb one letter at a time',
    minutesLabel: '~6 min',
    path: '/word-rungs',
    iconId: 'word-rungs',
  },
  {
    id: 'wordSquare',
    section: 'unhurried',
    name: 'Word Square',
    description: 'Fill rows and columns — no rush',
    minutesLabel: '~12 min',
    path: '/crossword-full',
    icon: '📰',
  },
  {
    id: 'hiddenWords',
    section: 'exploreFind',
    name: 'Hidden Words',
    description: 'Tap a line, submit the word you found',
    minutesLabel: '~8 min',
    path: '/crossword',
    icon: '📐',
  },
];

export function cozyHubGameById(id) {
  return COZY_HUB_GAMES.find((g) => g.id === id) ?? null;
}

export function cozyHubGamesForSection(sectionId) {
  return COZY_HUB_GAMES.filter((g) => g.section === sectionId);
}
